
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    
import style from '../../styles/content.module.css'

import { getLayout } from '../../components/sg/Layout'
import Header from '../../components/Header'
import classNames from 'classnames/bind'
import Link from 'next/link'
import Image from 'next/image'
import Footer from '../../components/sg/Footer'
import Cards from '../../components/sg/Cards'
import useTranslation from 'next-translate/useTranslation'
import Head from 'next/head'
import { useRouter } from 'next/router'
import LangHeaders from '../../components/LangHeaders'
export default function SavingsGuide () {
  const { t } = useTranslation('main')
  const c = classNames.bind(style)
  const router = useRouter()

  return (
    <>
      <Head>
        <title>新加坡黄金投资指南 - S.T.A.R. Grams账号</title>
        <meta property='og:title' key='og:title' content='新加坡黄金投资指南' />
        <meta property='og:url' key='og:url' content={router?.pathname} />
        <meta property='og:image' key='og:image' content='https://www.stargrams.app/images/og_starsavingsaccount-zh.png' />
        <meta property='og:description' key='og:description' content='黄金独特的属性使它成为每个投资组合或储蓄计划的重要组成部分。它能可靠地抵御通货膨胀，与其他主要资产类别不相关，并且在金融市场不确定的时候往往表现出色。毕竟，自1970年以来，黄金平均每年上涨约>7.8%。我们如何在新加坡最好的接触到黄金呢？' />
        <meta property='og:type' key='og:type' content='article' />
        <meta property='og:site_name' key='og:site_name' content={t('layout-goldsaver')} />
        <meta key='title' name='title' content='新加坡黄金投资指南' />
        <meta key='description' name='description' content='黄金独特的属性使它成为每个投资组合或储蓄计划的重要组成部分。它能可靠地抵御通货膨胀，与其他主要资产类别不相关，并且在金融市场不确定的时候往往表现出色。毕竟，自1970年以来，黄金平均每年上涨约>7.8%。我们如何在新加坡最好的接触到黄金呢？' />
        <LangHeaders {...router} withExtension />
      </Head>
      <Header showLogo />
      <div className={c('content')}>
        <div className={c('hero')}>
          <Image src='/images/goldbars.jpg' layout='fill' alt='Photo of Gold Bars' />
        </div>
        <div className={c('inner')}>
          <div className={c('single')}>
            <h3>新加坡黄金投资指南</h3><br />

            <p>黄金独特的属性使它成为每个投资组合或储蓄计划的重要组成部分。它能可靠地抵御通货膨胀，与其他主要资产类别不相关，并且在金融市场不确定的时候往往表现出色。毕竟，自1970年以来，黄金平均每年上涨约&gt;7.8%。</p>

            <p><i>我们如何在新加坡最好的接触到黄金呢？</i></p>

            <h4>直接拥有实物黄金</h4>

            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <p>直接拥有实物金条是最安全的黄金投资形式，您可以从我们的<a href='https://shop.silverbullion.com.sg' target='_blank' rel='noopener'>实体店</a>或任何其他有信誉的来源购买金条。然而，有几件关于实物黄金所有权的事情您应知晓，很多首次购买的客户都会忽略到这几点。</p>

            <ol>
              <li>
                <b>小的金银条和金银币有着更高的溢价</b>
                <p>您想购买的实物黄金数量越少，您就必须支付越高的溢价来购买它们。例如，一根1克的PAMP金条，有大约40%的溢价，您必须支付其黄金价值的140%来购买它。此溢价是金银交易商对其收取的服务费。而当您出售这个金条时，并无法把这个溢价挣回来，这么看来相当于您的投资立即损失了大约30%，这就是所谓的价差。换句话说，在您购买后，金价必须上涨30%以上才能在投资上获得利润。这给那些买不起溢价较低的大金条的小体量储蓄者和想定期购买少量金条的人带来了极大的负担。</p>
              </li>

              <li>
                <b>实物黄金只有在你能保存它时才是安全的。</b>
                {/* eslint-disable-next-line react/jsx-no-target-blank */}
                <p>把黄金藏在家中的床底并不是不可以，但如果您有更高的安全保障，在家里安置一个保险箱的费用也是不低的。而这一费用会直接显现在利润中。万一您的黄金被盗，尽管你尽了最大努力，但如果没有良好的保险，您的储蓄也会在一夜之间化为乌有。因此，如果您购买了实物黄金，您应该考虑在TSH这样的专业储蓄库存储您的黄金白银，我们的合作伙伴<a href='https://www.silverbullion.com.sg' target='_blank' rel='noopener'>Silver Bullion</a>提供高安全性和保险的专业金库。虽然存储费用是定期订阅，而不是一次性收费，但<a href='https://thesafehouse.sg' target='_blank' rel='noopener'>The Safe House</a>存储和保险的贵金属数量大，效率高，可以提供真正的低费率，让您省时省心。</p>
              </li>
            </ol>

            <h4>黄金交易所交易基金--SPDR黄金信托基金（GLD）</h4>

            <p>GLD是一个比较热门的选择，尤其是您已经在经纪人那里开设了账户。您可以几乎在没有价差的情况下像股票或债券一样买卖它。几乎所有的财富经理，甚至像StashAway这样的数字顾问，都是通过GLD来为客户的投资组合增加黄金。但这种交易所交易基金有其自身的风险和弊端。</p>
            <ol>
              <li>
                <b>对方手风险</b>
                <p>大部分支持GLD的黄金是由汇丰银行管理的，作为回报，汇丰银行与其他供应商签订了托管服务合同，这些供应商与更多的分包商签订合同来完成这项工作。很不幸，参与该ETF的保管人员们都是<a href='https://www.forbes.com/sites/oliviergarret/2017/03/22/gld-vs-physical-gold-which-is-the-better-investment-now/?sh=7bd542682a0b' target='_blank' rel='noopener nofollow noreferrer'>很不透明</a>，且其背后的支撑物都是未经审计的。因此，当黄金需求大幅上升，或对汇丰银行及其保管人员的稳定性提出质疑，许多人预计GLD的股价会比实物黄金价格低很多，这并不出奇。在以上所诉的种种不确定性因素下，黄金的稳定和持久性显得尤其突出。</p>
              </li>
              <li>
                <b>储存费用和无保险</b>
                <p>许多GLD持有者并不知道其实每年会有0.4%的费率产生。除此之外GLD 被认为是一种投机性投资，一旦发行人、托管人或黄金受到质疑，您将可能面临全部损失。</p>
              </li>
              <li>
                <b>最少购买一股</b>
                <p>目前大约需要180美金去购买一股GLD。如果您每月需节省50美金，这将无法达到您的预期。</p>
              </li>
              <li>
                <b>无法赎回</b>
                <p>除非您是体量极大的投资者，您根本无法以实物黄金的形式赎回您在GLD里的份额。</p>
              </li>
            </ol>

            <h4>UOB (大华银行) 的黄金储蓄账户</h4>

            <p>是新加坡家喻户晓且拥有良好信誉的银行，他们以在柜台出售公平价格的实物黄金而出名。自然而然，人们会认为在银行开立黄金储蓄账户是一种简单的、数字化的方式，并且能够通过智能手机应用程序获得接触黄金的机会。但是此类产品以及其他由银行创造的相关黄金储蓄的产品有一些值得我们注意的地方。:</p>
            <ol>
              <li>
                <b>实物黄金在这里并不存在，所以您也无法赎回实物黄金</b>
                <p>UOB 的黄金用户经常误认为自己在银行的黄金储蓄账户持有的黄金是由UOB金库中的实物黄金支持的。但事实并非如此。<a href='https://www.uob.com.sg/web-resources/personal/pdf/personal/invest/goldsilver/overview/tnc-cts.pdf' target='_blank' rel='noopener noreferrer nofollow'>UOB</a>仅售卖给您以数字显示的金价，而且他们有资格去按照他们认为合适的方式去管理您的投资。</p>
              </li>
              <li>
                <b>这个不是押金</b>
                <p>新加坡政府为每家银行提供高达7.5万美元的本地银行存款保险，以防止银行破产。那如果没有实物黄金为大华银行的黄金储蓄账户作为支持，当UOB陷入困境时，政府肯定会来救援，并为您的黄金储蓄账户的持有量提供保险，对吗？不，UOB黄金储蓄账户不在存款保险计划的范围内，这将导致您面临损失全部黄金投资的风险。</p>
              </li>
              <li>
                <b>至少需要购置5克黄金</b>
                <p>将近400美元金价，对于很多人来说并不是什么小数字。</p>
              </li>
            </ol>

            <h4>使用S.T.A.R. Grams账号</h4>

            <p>若您读到这里了，那么我们必须和您分享一个极好的消息！我们专门为需要储存实物黄金的客户创造了一个前所未有的电子黄金储存选择。我们一起来更进步的了解这个S.T.A.R. Grams账号的一系列好处：</p>

            <ol>
              <li>
                <b>完全由真实、实体的、投资级别的黄金支持，安全储存，全方位受保险。</b>
                <p>有些人会说我们延续着老派的作风，但我们能够确保在金库中有足够的黄金分配，以满足您账户里持续有足够的实物黄金。就像当年银行的做法一样。而且，这不仅由专业人士定期审计，您还可以通过我们的在线黄金探索器公开审计。使用这个<a href='/explore' target='_blank' rel='noopener noreferrer'>黄金探索器</a>，您可以获取我们账户的每根金条的所有细节，甚至图片。但这同时也意味着我们需要用到一些成本来存储和保险您的黄金，我们为此每年向您收取0.35%。这完全低于相对高风险的GLD ETF的存储费用。</p>
                <p>这对您意味着什么呢？这意味着，在一个合理公道的价格前提下，我们仍会向您保证，即使因某种原因我们破产了，黄金并不会受任何影响并会一直以实物的形式存在。您在我们这里持有的账户也能够兑现。这也意味着，如果黄金被盗，甚至消失了，您都可以从我们的保险中索赔损失。</p>
              </li>
              <li>
                <b>从0.01克起储存</b>
                <p>这相当于当前0.7美元的价格，每个人都可以通过银行转账或进入我们的商店存入现金的方式来累计黄金。由于只有2%的溢价，将黄金加入您的GSA账户很可能是最便宜快捷的方式，并由100%的黄金实物产品完全支持，同时受到前方位的保险。</p>
              </li>
              <li>
                <b>开始储存和兑换更大的金/银条</b>
                <p>正如我们之前所说的一样，直接拥有实物黄金可能是最安全的方式。但使用GSA账户您无需花高昂的价格购入大金条（虽然他们的溢价较低），您可以直接以超低溢价（2%）。当您的账户有足够多的克重，您即可兑换更大的金条，在溢价上做出节省。</p>
              </li>
            </ol>

            <p>我们用了非常多的时间与心血去制作一个更好更高效的黄金储蓄产品。如果您喜欢这篇文章和我们的产品，请告诉我们，并与您的家人朋友分享。我们的团队将非常乐意在任何时候解决您所有的疑问。</p>
            <p>您现在就可以<Link href='/signup'><a>免费开立</a></Link>属于您的的GSA账户。今天就开始智慧储蓄吧!</p>

          </div>
          <div className={c('promotion')}>
            {t('banner-mission-1')}<br />
            {t('banner-mission-2')}<br />
            <br />
            <br />
            <Link href='/signup'>
              <button className='goldenshimmer' title={t('banner-signup-button-title')}>{t('banner-signup-button')}</button>
            </Link>
            <span className={c('termsnote')}>{t('banner-signup-subtext')}</span>
          </div>
        </div>
      </div>
      <Cards />
      <Footer />
    </>
  )
}

SavingsGuide.getLayout = getLayout


    export async function getStaticProps(ctx) {
        
        
        return {
          
          
          props: {
            
            ...(await __loadNamespaces({
              ...ctx,
              pathname: '/sg/singapore-guide-to-gold-savings-and-gold-investments-zh',
              loaderName: 'getStaticProps',
              ...__i18nConfig,
              loadLocaleFrom: (l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default),
            }))
          }
        }
    }
  